module.exports = __webpack_public_path__ + "static/media/1.cf4da3aa.jpeg";